import { render, staticRenderFns } from "./ElementInfo.vue?vue&type=template&id=09c7427c&"
import script from "./ElementInfo.vue?vue&type=script&lang=js&"
export * from "./ElementInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports